import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { withRouter } from 'react-router';

import Button from '@chama/ui-components/components/Button';
import Logo from '@chama/ui-components/components/Logo';

import './Login.layout.css';

const translateErrors = ({ code }, formatMessage) => {
  let message;
  switch (code) {
    case 'auth/popup-closed-by-user':
      message = formatMessage({
        id: 'login_error_closed_modal',
        defaultMessage: 'Oops, you closed the popup',
      });
      break;
    case 'unauthorised':
      message = formatMessage({
        id: 'login_error_unauthorised',
        defaultMessage: "You don't have permission",
      });
      break;
    default:
      message = formatMessage({
        id: 'generic_error_message',
        defaultMessage: 'Oops, unknown error',
      });
      break;
  }
  return message;
};

const Login = ({ loading, success, error, onLogin, router, intl: { formatMessage } }) => {
  if (success) {
    router.push('/');
    return null;
  }

  let errorMessage = null;
  if (error)
    errorMessage = <div className="Login__errors">{translateErrors(error, formatMessage)}</div>;

  return (
    <div className="Login">
      <div className="Login__logo-container">
        <Logo />
      </div>
      <div className="Login__greeting">
        {formatMessage({
          id: 'login_title',
          defaultMessage: 'Sign in to continue to the Chama dealer tool',
        })}
      </div>
      <div className="Login__gbutton-container">
        <Button onClick={onLogin} id="login-submit-btn" fullWidth type="submit" isLoading={loading}>
          {formatMessage({
            id: 'login_button_sign_in',
            defaultMessage: 'Log in',
          })}
        </Button>
      </div>
      {errorMessage}
    </div>
  );
};

Login.propTypes = {
  loading: PropTypes.bool.isRequired,
  onLogin: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired,
  error: PropTypes.any.isRequired,
  router: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(Login));



// WEBPACK FOOTER //
// ./src/modules/auth/components/Login/Login.layout.jsx